import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import { createPinia, PiniaVuePlugin } from 'pinia'
import I18NextVue from 'i18next-vue'
import { initI18n } from 'www/utils'
import DoctorAppointmentForm from 'src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/DoctorAppointmentForm.vue'
import { mountIfNoRedirect } from 'www/doctors.blocks/common/auto-redirect-to-mt/functions'

const mountNode = document.querySelector('#doctor-appointment-form')

if (mountNode) {
  mountIfNoRedirect(async () => {
    const { i18next } = await initI18n({ bundle: 'vue_components/common/AppointmentPage' })

    await initI18n({ bundle: 'vue_components/common/FamilyProfiles' })

    Vue.use(I18NextVue, { i18next })
    Vue.use(PiniaVuePlugin)

    new Vue({
      vuetify,
      el: mountNode,
      name: 'DoctorAppointmentFormRoot',
      pinia: createPinia(),
      components: {
        DoctorAppointmentForm,
      },
    })
  })
}
